import axios from 'axios';
import { detailMessage } from './apiError';

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');
export const API = `${BACKEND_URL}/api`;
export const resolveApiAssetUrl = (url) => (
  BACKEND_URL && typeof url === 'string' && url.startsWith('/api/')
    ? `${BACKEND_URL}${url}`
    : url
);
export const createIdempotencyKey = () => (
  globalThis.crypto?.randomUUID?.()
  || `${Date.now()}-${Math.random().toString(36).slice(2)}`
);

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('pusubet_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Kapalı bir hizmete gelen istek, sıradan bir yetki hatasından ``X-Service-
// Notice`` başlığıyla ayrılır (bkz. backend/services/license.py). Oyuncuya
// küçük bir bildirim balonu yerine açıklayıcı bir pencere gösterilir:
// components/ServiceNoticeModal.jsx bu olayı dinler.
export const SERVICE_NOTICE_EVENT = 'bhs:service-notice';
const SERVICE_NOTICE_HEADER = 'x-service-notice';

// Hata gövdesindeki `detail` her zaman metne indirgenir. Doğrulama
// hatalarında (422) FastAPI burayı dizi olarak döner; arayüzün her yerinde
// `error.response?.data?.detail` doğrudan ekrana basıldığı için dizi geçerse
// React ağacı çöker ve kullanıcı boş ekran görür. Bkz. lib/apiError.js
client.interceptors.response.use(
  (res) => res,
  (error) => {
    const data = error.response?.data;
    if (data && typeof data === 'object' && typeof data.detail !== 'string' && 'detail' in data) {
      error.response.data = { ...data, detail: detailMessage(data.detail) || 'Bir hata oluştu' };
    }
    // Ters vekilin 413'ü uygulamaya hiç ulaşmaz ve gövdesi nginx'in HTML
    // sayfasıdır: ekranlar genel "Dosya yükleme başarısız." yazıyor, yönetici
    // sebebi dosyada arıyordu. Sebep sunucudaki `client_max_body_size`'tır
    // (bkz. deploy/apply-nginx-hardening.sh). Backend'in kendi 413'ü
    // `detail` taşır ve ona dokunulmaz.
    if (error.response?.status === 413 && typeof error.response.data?.detail !== 'string') {
      error.response.data = {
        detail: 'Dosya sunucunun yükleme sınırını aştı (HTTP 413). Sınır sunucudaki nginx '
          + 'ayarındadır; yöneticiniz deploy/apply-nginx-hardening.sh betiğini çalıştırmalıdır.',
      };
    }
    if (error.response?.headers?.[SERVICE_NOTICE_HEADER]
        && typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(SERVICE_NOTICE_EVENT, {
        detail: { message: error.response?.data?.detail || '' },
      }));
    }
    return Promise.reject(error);
  },
);

export default client;
